import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addBalance: 'Add money to my account',
    orderCard: 'Order\nmy first card',
    title: 'Complete your account setup',
  },
  fr: {
    addBalance: 'Ajouter de l’argent sur mon compte',
    orderCard: 'Commander\nma première carte',
    title: 'Terminez la configuration de votre compte',
  },
});

export default locales;
